import React from 'react';
import ContentTitles from "@/ui/content-titles/content-titles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import StarRateIcon from '@mui/icons-material/StarRate';
import {QRGenerator} from "@/ui/qr-generator/qr-generator";
import {BUSINESS_NAME, googleDetails} from "@/content";


const GoogleReviews = () => {
    // const {businessDetails: {googleReviewLink, businessName}} = useBusinessStore();

    const {googleReviewLink} = googleDetails


    if (!googleReviewLink) {
        return null; // Do not render if the link is not available
    }

    return (
        <Box pt={4} pb={8} align='center'>
            <ContentTitles
                title={`${BUSINESS_NAME} on Google`}
                subTitle='Read our reviews and leave your feedback'
            />
            <div>
                <Box>
                    {Array.from({length: 5}).map((_, index) => (
                        <StarRateIcon key={index} sx={{color: '#ffb300', fontSize: '38px'}}/>
                    ))}
                </Box>
            </div>
            <div>
                <QRGenerator value={googleReviewLink} size={200}/>
            </div>
            <div>
                <Button
                    href={googleReviewLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Leave a review on Google"
                    variant='contained'
                    className="w-4/5 sm:w-auto"
                >
                    Leave {BUSINESS_NAME} a review on Google
                </Button>
            </div>
        </Box>
    );
};

export default GoogleReviews;
